<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { interactionMixin } from "src/modules/interactions_module.js";
import { get } from "lodash";

export default {
  mixins: [fandomBasicMixin, interactionMixin],
  data() {
    return {
      hoverIndex: -1,
      hovering: false
    };
  },
  mounted() {
    this.leaveAction();
  },
  methods: {
    getContentResponsiveImageURL: Fandom.getContentResponsiveImageURL,
    updateInteraction(vote) {
      if (Fandom.isUserRegistered()) {
        this.updateVoteInteraction(this.content, this.interactionRecord, this.voteInteraction, vote);
      } else {
        Fandom.emit("toggle-registration-vote-modal");
      }
    },
    starClass(index) {
      const active = (this.userVote && this.hoverIndex < 0) ? (index < this.userVote) : (this.hoverIndex > -1 && index <= this.hoverIndex);
      return active ? this.activeStarClass : "text-white";
    },
    overAction(index) {
      this.hoverIndex = index;
      this.hovering = true;
    },
    leaveAction() {
      this.hoverIndex = this.defaultVote - 1;
      this.hovering = false;
    }
  },
  computed: {
    userVote() {
      if (this.isInteractionDone(this.content, this.voteInteraction)) {
        return this.getUserInteraction(this.content, this.voteInteraction).data.vote;
      }
      return false;
    },
    activeStarClass() {
      return (this.userVote || this.hovering) ? "text-gray-900" : "white";
    },
    activeTextClass() {
      return this.userVote ? "text-primary" : "text-gray-900";
    },
    interactionRecord() {
      return get(this, ["content", "vote"], false);
    },
    voteInteraction() {
      return get(this, ["interactionRecord", "interaction"], false);
    },
    minVote() {
      return get(this, ["content", "min_vote"], 1);
    },
    maxVote() {
      return get(this, ["content", "max_vote"], 5);
    },
    range() {
      const size = this.maxVote - this.minVote + 1;
      return [...Array(size).keys()].map(i => i + 1);
    },
    textVote() {
      return this.hoverIndex > -1 ? this.hoverIndex + 1 : this.defaultVote;
    },
    userMessage() {
      return this.userVote ? "globals.thank_you" : "globals.vote";
    },
    averageVote() {
      const contentUserInfo = this.getContentUserInfo(this.content);
      const numberOfVotes = get(contentUserInfo, ["id_to_interaction", this.voteInteraction.id, "votes_info", "number_of_votes"], 0);
      const votesSum = get(contentUserInfo, ["id_to_interaction", this.voteInteraction.id, "votes_info", "votes_sum"], 0);

      return numberOfVotes > 0 ? Math.round(votesSum / numberOfVotes) : 0;
    },
    defaultVote() {
      return this.userVote ? this.userVote : this.averageVote;
    }
  }
};
</script>

<template>
  <div vote-interaction-component class="vote-component">
    <div class="container">
      <div class="row align-items-center justify-content-center">
        <div class="col-12 col-lg-7">
          <div class="w-100 py-4 px-3 px-md-5 d-flex flex-md-nowrap flex-wrap align-items-center justify-content-between shadow rounded-lg bg-white">
            <div v-if="content.author" :class="voteInteraction ? 'd-md-block':'flex-md-row'" class="w-100 d-flex flex-column justify-content-center align-items-center">
              <span class="pb-3 pb-md-0">{{ft("globals.content_edited_by")}}</span>
              <img :src="content.author.image.url" v-if="content.author.image" class="author-image ml-md-4"/>
            </div>
            <template v-if="voteInteraction">
              <div class="divider w-100 my-4 d-md-none"></div>
              <div class="w-100 d-flex justify-content-end align-items-center ml-0 ml-md-auto flex-column flex-md-row">
                <div class="px-2 position-relative" :class="activeTextClass">
                  <div class="divider divider--vertical my-4 d-none d-md-block"></div>
                  {{ft(userMessage)}}
                </div>
                <div class="pt-3 pt-md-0">
                  <div 
                    v-for="(vote, index) in range"
                    :key="`star-${index}`"
                    class="px-1 d-inline-flex align-items-center" 
                    @click="updateInteraction(vote)"
                    @mouseover="overAction(index)"
                    @mouseleave="leaveAction"
                  >
                    <svg class="star cursor-pointer color-primary" viewBox="0 0 26 25" :class="starClass(index)">
                      <path d="M12.81 1.142c.504.051.6.148.652.27h0l3.161 7.601 8.206.658c.138.011.258.077.341.174.083.098.129.227.118.364-.01.132-.073.254-.173.34h0l-6.253 5.356 1.91 8.008c.033.134.007.268-.06.377-.067.11-.175.193-.31.225-.128.03-.264.01-.376-.06h0L13 20.165l-7.026 4.29c-.117.072-.253.09-.378.06-.124-.03-.237-.108-.309-.226-.069-.113-.09-.248-.06-.376h0l1.91-8.008-6.252-5.356c-.104-.09-.163-.213-.173-.341-.01-.128.03-.259.119-.364.086-.1.208-.162.34-.173h0l8.206-.658 3.161-7.601c.053-.128.153-.221.271-.27z"/>
                    </svg>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.vote-component {
  @include font-size(0.875rem);

  .author-image {
    height: auto;
    width: auto;
    display: inline-block;
    max-width: 48%;
    max-height: 2.5rem;
  }

  .divider {
    border-top: 1px solid $gray-ccc;

    &--vertical {
      position: absolute;
      left: -25px;
      top: -47px;
      height: 66px;
      border-top: 0;
      border-right: 1px solid $gray-ccc;
    }
  }

  .star {
    width: 1.5625rem;
    height: 1.5625rem;
    fill: currentColor;
    stroke: $gray-900;
    fill-rule: evenodd;
  }
}
</style>
